export default __webpack_public_path__ + "static/media/G7Countries.f88d035f.jpg";